import React from "react";
import { useHistory, useParams } from "react-router-dom";

import BulkMessagingForm from "../../components/BulkMessagesModal";

export default function BulkMessagingWizard() {
	const history = useHistory();
	const { id } = useParams();
	const bulkMessageId = id ? Number(id) : undefined;

	return (
		<BulkMessagingForm
			bulkMessageId={Number.isNaN(bulkMessageId) ? undefined : bulkMessageId}
			onCancel={() => history.push("/bulk-messaging")}
			onSaved={() => history.push("/bulk-messaging")}
		/>
	);
}
